import { acceptRatingValue } from '../../field-viewer/shared-normalizers';
export const dextRatingInputViewer = {
    normalizeLoadedValue: acceptRatingValue
};

//# sourceMappingURL=definition-viewer.js.map